import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { confirmAlert } from "react-confirm-alert";
import { Helmet } from "react-helmet";
import { BaseComponent } from "BaseComponent";
import {
  openGenerateBadgeModal,
  blankBadgeUserList,
  searchUsersToGenerateBadgeLimited,
  generateBadges, // print pdf for badges
} from "BadgeDesignAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { centToPixel, centToPixelDouble } from "BaseFunctions";
import {
  COMMON_FAIL_MESSAGE,
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_LOCAL_URL,
  BASE_IMAGES_URL,
} from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";

class GenerateOneBadge extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      search: "",
      pdfHTML: "",
      pdfJS: "",
    };

    this.closeModal = this.closeModal.bind(this);
  }

  componentWillUnmount() {
    this.reinitializeStatesAndProps();
  }

  // Reintialize states and props
  reinitializeStatesAndProps() {
    // States
    this.setState({
      loading: false,
      search: "",
      pdfHTML: "",
      pdfJS: "",
    });

    // Props
    this.props.blankBadgeUserList();
  }

  closeModal() {
    this.props.openGenerateBadgeModal(false);
    /* When closing "Select Attendee & Generate" modal black the current template id*/
    this.props.setStateCurrentTemplateId("");
    this.reinitializeStatesAndProps();
  }

  /**
   * Badge search by input
   */
  onSearchUser = (event) => {
    let { session } = this.props;
    var searchText = event.target.value;
    // console.log("searchText :- ", searchText);

    if (searchText !== "") {
      // Search word present
      this.props.searchUsersToGenerateBadgeLimited(
        session,
        searchText,
        (callback) => {}
      );
    } else {
      this.props.blankBadgeUserList();
    }

    this.setState({ search: searchText, pdfHTML: "" });
  };

  demoFromHTML = (response) => {
    let fileName = response.htmlname;

    let fileURL = response.successS3
      ? BASE_IMAGES_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY
      : BASE_IMAGES_LOCAL_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY;

    this.setState({
      pdfHTML: response.htmlcontent,
      pdfJS: response.jsscript,
    });

    // window.open(fileURL);
  };

  handleUserSelect = (item) => {
    let { session, currentTemplateId } = this.props;
    // console.log("user :- ", item);
    this.setState({ search: item.username });

    let dataObject = {
      templateid: parseInt(currentTemplateId), // Badge template id
      badgefor: "choose_attendees",
      categoryid: "", // appuser_groups -> id
      categoryname: "",
      pdfsettings: false,
      usersnotin: item.appuserid,
      requesttype: "generateBadgePdf",
    }; // Initialize blank object to send as params
    // console.log("dataObject :- ", dataObject);

    this.props.blankBadgeUserList(); // Make blank user searched list

    this.setState({ loading: true });
    /* API call Generate badge pdf to create pdf  */
    this.props.generateBadges(session, dataObject, (callback) => {
      // console.log("callback :- ", callback);
      this.setState({ loading: false });

      if (callback.success === 0) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.demoFromHTML(callback);
      }
    });
  };

  renderList = () => {
    return _.map(this.props.userList.data, (item, index) => {
      return (
        <li
          key={`use-list-${index}`}
          onClick={() => this.handleUserSelect(item)}
        >
          {item.username}
        </li>
      );
    });
  };

  render() {
    let { search, pdfHTML, pdfJS, loading } = this.state;
    var { isGenerateBadgeModalOpen, userList, badgetList, currentTemplateId } =
      this.props;
    // console.log("userList :- ", userList);

    var selectedBadge = _.filter(badgetList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    // console.log("selectedBadge :- ", selectedBadge);
    var ifWidth = 500;
    var ifHeight = 500;
    if (selectedBadge.length > 0) {
      var badgeSizeArr = _.split(selectedBadge[0].badge_size, "#");
      ifWidth = centToPixelDouble(badgeSizeArr[0]);
      ifHeight = centToPixelDouble(badgeSizeArr[1]);
    }

    var existingScript = document.getElementById("jspdfgenerate");

    if (existingScript) {
      existingScript.remove();
    }

    if (!existingScript && pdfJS !== "") {
      // console.log(1);
      const script = document.createElement("script");
      script.text = `${pdfJS}`;
      script.id = "jspdfgenerate";
      document.body.appendChild(script);
    }

    // console.log("W*H :- ", ifWidth, ifHeight);
    // console.log("existingScript :- ", existingScript);

    return (
      <div className="badge-generate-modal">
        <Modal
          className="modal-container"
          dialogClassName="generateBadgeModal"
          show={isGenerateBadgeModalOpen}
          onHide={this.closeModal}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.dashboard_badgedesign_generate_badge_modal_header}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="badge-generate-userlist-container position-relative">
              <input
                className="form-control badge-custom-search"
                placeholder={LocaleStrings.dashboard_badgedesign_search}
                type="search"
                value={search}
                onChange={this.onSearchUser}
              />
              {search !== "" ? (
                <img
                  className="clear-search"
                  src="../../style/images/custom-icons/cross-black.png"
                  onClick={() => this.reinitializeStatesAndProps()}
                />
              ) : (
                ""
              )}

              {userList && userList.data ? (
                <ul className="userlist-section">{this.renderList()}</ul>
              ) : (
                ""
              )}
            </div>

            {pdfHTML !== "" ? (
              <div className="badge-view-container custom-align-center mt-15 mb-15">
                <div
                  className="badge-view"
                  dangerouslySetInnerHTML={{ __html: pdfHTML }}
                />
              </div>
            ) : loading === true ? (
              <div className="loader-container">
                <Loader />
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-custom-white" onClick={this.closeModal}>
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    isGenerateBadgeModalOpen: state.isGenerateBadgeModalOpen, // Generate Badge modal
    userList: state.dashboardBadgeUserList,
    badgetList: state.dashboardBadgeList,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openGenerateBadgeModal,
  blankBadgeUserList,
  searchUsersToGenerateBadgeLimited,
  generateBadges, // Generate pdfs for badges
})(GenerateOneBadge);
